import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgPersonIconWithBadge',
})
export default class CmgBag extends Vue {

  @Prop({ required: true, type: Number })
  badgeCount!: number;

  @Prop({ required: false, default: 'gold' })
  iconColor!: 'gold' | 'white';

  get personIconUrl(): string {
    return this.$appStore.state.cms.images.icons.person.default;
  }
}
